import { Repository } from "src/firebase/firestore/repository";
import { UserBalance } from "../types/user.entity";

export class UserBalanceRepository extends Repository<UserBalance> {
  constructor() {
    super("users_balance");
  }

  async findByUserId(userId: string): Promise<UserBalance | null> {
    try {
      return await this.findById(userId);
    } catch (error) {
      console.error("Error fetching user balance:", error);
      return null;
    }
  }
}

export const userBalanceRepository = new UserBalanceRepository();
